import { Component, OnInit } from '@angular/core';
import { ApiSearchRequestTable } from '../../models/api-search-request-table';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import {
  TreeViewInputModel,
  TreeViewModel,
} from '../../models/tree-view-model';
import { ApiResponseTable } from '../../models/api-response-table';
import { EditMenu, Menu } from '../../models/menu';

@Component({
  selector: '.app-menu-model.container-xxl.flex-grow-1.p-0',
  templateUrl: './menu-model.component.html',
  styleUrls: ['./menu-model.component.css'],
})
export class MenuModelComponent implements OnInit {
  public constructor(
    private apiService: UserApiService,
    private logger: LoggerService
  ) {
  }

  public loading: boolean=true;
  public apiDataModel: EditMenu[] = [];
  public apiResponse!: ApiResponseTable;
  public saveChange:boolean=false;

  public ngOnInit() {
    try {
      this.loading = true;

      let url = `Menu?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          this.apiDataModel=this.mapData(result)??[];
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {
          this.loading=false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public mapData(apiInput: any):any[] | undefined {
    try {
      if (apiInput == null) {
        return;
      }

      apiInput = apiInput.data?.items.sort((a, b) => a.order - b.order);

      var grandParents = apiInput.filter((current) => current.parentId == null);

      let result:any[]=[];

      grandParents.forEach((grandParent) => {

        let grandParentViewModel=new EditMenu(grandParent);
        var parents = apiInput
        .filter((current) => current.parentId == grandParent.id);

        parents.forEach(parent => {
          
          let parentViewModel=new EditMenu(parent);
          var children = apiInput
          .filter((current) => current.parentId == parent.id);

          children.forEach(child => {
            let childViewModel=new EditMenu(child);
            
            if(parentViewModel.children==null)
              parentViewModel.children=[];

            parentViewModel.children.push(childViewModel);
          });

          if(grandParentViewModel.children==null)
            grandParentViewModel.children=[];

          grandParentViewModel.children.push(parentViewModel);
        });

        result.push(grandParentViewModel);
      });

      return result;
    
    } catch (error) {
      this.logger.addException(error, false);
      return;
    }
  }

  public saveData(item) {
    try {
      this.loading = true;

      var backendJson = {
        order:item.order,
        viewName:item.viewName,
        icon:item.icon,
        urlField:item.urlField,
        endPoint:item.endPoint,
        color:item.color
      };

      const editUrl = `Menu/${item.id}`;
      this.apiService
        .patchItem(new ApiRequestModel(editUrl, backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.saveChange=true;
            } else {
              this.logger.addBackEndMessage(result);
            }
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }
}
